export const constants = {
  origin: { CLASS_STUDENT_LESSON_PROGRESS: 'class_student_lesson_progress' },
  pages: { STUDENT_LESSON_PROGRESS: 'Student Lesson Progress' },
  events: {
    CLICKED_LINK_TO_STUDENT_COURSE_PROGRESS:
      'clicked link to student course progress',
    CLICKED_LINK_TO_STUDENT_NOTEBOOK: 'clicked link to student notebook',
    LESSON_INSIGHTS_TO_RESULTS_GRID_LINK_CLICKED:
      'Lesson Insights to Results Grid Link Clicked',
    EM_INSIGHTS_TO_RESULTS_GRID_LINK_CLICKED:
      'Exam Insights to Results Grid Link Clicked',
    TASK_INSIGHTS_TO_RESULTS_GRID_LINK_CLICKED:
      'Task Insights to Results Grid Link Clicked',
  },
};
